import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IReferralFormQuestionGroup } from "../../shared/models/interfaces/referral-form-question-group";
import { IQuestionGroupQuestion } from "../../shared/models/interfaces/question-group-question";
import { QuestionTypes } from "../../shared/enums/question-types.enum";
import Criteria = QuestionTypes.Criteria;
import { FormTypes } from "../../shared/enums/form-types.enum";

@Component({
  selector: 'app-referral-form-question-group',
  templateUrl: './referral-form-question-group.component.html',
  styleUrls: ['./referral-form-question-group.component.scss']
})
export class ReferralFormQuestionGroupComponent implements OnInit {

  @Input() referralFormQuestionGroup: IReferralFormQuestionGroup;
  @Input() isReadOnly: boolean;
  @Input() questionGroupIndex: number;
  @Input() formType: FormTypes;
  @Output() questionAnsweredEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  getQuestionGroupQuestions() {
    return this.referralFormQuestionGroup.questionGroup.questionGroupQuestions.sort(s => s.index);
  }

  questionAnswered(qgq: IQuestionGroupQuestion) {
    if (qgq && qgq.question && qgq.question.isRequired && (this.formType && this.formType === FormTypes.PostVisit || qgq.question.questionTypeId === Criteria)) {
      this.questionAnsweredEvent.next(qgq);
    }
  }
}
